import { Button, useNotify, useRefresh } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";
import DeleteIcon from "@mui/icons-material/Delete";

const RemoveDialog = ({ curriculumId, id, label, type }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleDelete = async () => {
    await dataProvider.customRequest(specialistRequests.deleteCurriculumEntity(curriculumId, type, id), null, "DELETE");
    notify(`Успешно изтриване на ${label}!`, { type: "success" });
    refresh();
  };

  return (
    <ConfirmModal
      titleContent={`Изтриване на ${label}`}
      onConfirm={handleDelete}
      message={`Сигурни ли сте, че искате да изтриете ${label}?`}
      triggerButton={
        <Button
          label="Изтрий"
          color="error"
          variant="contained"
          startIcon={<DeleteIcon />}
        />
      }
    />
  );
};

export default RemoveDialog;
